import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, Mail, Phone, MapPin, Facebook, Instagram, Twitter, Gem } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const LOGO_URL = '/marissa_logo.png';

export default function Footer() {
  const { settings } = useSettings();
  
  return (
    <footer className="bg-[#FEFAF3]/80 backdrop-blur-md text-[#1a3a5c] mt-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <img 
                src={LOGO_URL} 
                alt="Logo" 
                className="h-14 w-auto md:h-16 object-contain"
              />
            </div>
            <p className="text-[#1a3a5c]/80 text-sm">Exquisite jewelry crafted with passion and precision.</p>
          </div>
          <div>
            <h3 className="text-[#1a3a5c] font-serif font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-[#1a3a5c]/80">
              <li><Link to="/products" className="hover:text-[#1a3a5c] transition-colors">All Products</Link></li>
              <li><Link to="/products?category=gold" className="hover:text-[#1a3a5c] transition-colors">Gold Jewelry</Link></li>
              <li><Link to="/products?category=diamond" className="hover:text-[#1a3a5c] transition-colors">Diamond Jewelry</Link></li>
              <li><Link to="/products?category=silver" className="hover:text-[#1a3a5c] transition-colors">Silver Jewelry</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-[#1a3a5c] font-serif font-semibold mb-4">Policies</h3>
            <ul className="space-y-2 text-sm text-[#1a3a5c]/80">
              <li><Link to="/policy/terms_conditions" className="hover:text-[#1a3a5c] transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/policy/privacy_policy" className="hover:text-[#1a3a5c] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/policy/return_policy" className="hover:text-[#1a3a5c] transition-colors">Return Policy</Link></li>
              <li><Link to="/policy/shipping_policy" className="hover:text-[#1a3a5c] transition-colors">Shipping Policy</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-[#1a3a5c] font-serif font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm text-[#1a3a5c]/80">
              {settings.contact_email && (
                <li className="flex items-center"><Mail className="h-4 w-4 mr-2 text-[#1a3a5c]" />{settings.contact_email}</li>
              )}
              {settings.contact_phone && (
                <li className="flex items-center"><Phone className="h-4 w-4 mr-2 text-[#1a3a5c]" />{settings.contact_phone}</li>
              )}
              {settings.contact_address && (
                <li className="flex items-center"><MapPin className="h-4 w-4 mr-2 text-[#1a3a5c]" />{settings.contact_address}</li>
              )}
            </ul>
            <div className="flex space-x-3 mt-4">
              {settings.facebook_url && <a href={settings.facebook_url} target="_blank" rel="noopener noreferrer" className="text-[#1a3a5c]/80 hover:text-[#1a3a5c]"><Facebook className="h-5 w-5" /></a>}
              {settings.instagram_url && <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" className="text-[#1a3a5c]/80 hover:text-[#1a3a5c]"><Instagram className="h-5 w-5" /></a>}
              {settings.twitter_url && <a href={settings.twitter_url} target="_blank" rel="noopener noreferrer" className="text-[#1a3a5c]/80 hover:text-[#1a3a5c]"><Twitter className="h-5 w-5" /></a>}
            </div>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-[#1a3a5c]/10 text-center text-sm text-[#1a3a5c]/80">
          <p>&copy; {new Date().getFullYear()} {settings.store_name || 'Marissa Gold'}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
